import LoadingFailure from './LoadingFailure';
import { retryLoad } from './retryLoad';
import LoadingScreen from './LoadingScreen';
import React, { Component, lazy, Suspense } from 'react';

class PageLoadBoundary extends Component {
  state = { failed: false, error: null };

  static getDerivedStateFromError(error) {
    return { failed: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Page failed to load', error, info);
  }

  render() {
    if (this.state.failed) {
      return <LoadingFailure error={this.state.error} />;
    }
    return this.props.children;
  }
}

export default function lazyPage(load) {
  const Page = lazy(() => retryLoad(load));
  return function LazyPage(props) {
    return (
      <PageLoadBoundary>
        <Suspense fallback={<LoadingScreen />}>
          <Page {...props} />
        </Suspense>
      </PageLoadBoundary>
    );
  };
}
